import { render } from "./J2026.vue?vue&type=template&id=ecf508d8"
import script from "./J2026.vue?vue&type=script&lang=js"
export * from "./J2026.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Git-Local\\afm.git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__